import { useStaticQuery, graphql } from 'gatsby';

const Query = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulAcademyApprovalPage {
        title
        subtitle
        image {
          ...Image
        }
        description {
          raw
        }
        accreditations {
          ...AcademyLinkList
        }
        primaryButton {
          ...AcademyButton
        }
        searchTitle
        searchButton {
          ...AcademyButton
        }
      }
      allContentfulAcademyStateApproval(sort: [{country: ASC}, {state: ASC}]) {
        nodes {
          id
          state
          country
          slug
        }
      }
    }
  `)
  return data
}

export default Query
